import { useContext, useState } from "react"
import { login_user_service } from "services/user_services"
import { AppContext } from "store/context/AppContext"
import { useNavigate } from "react-router-dom"
import useCancelToken from "hooks/useCancelToken"
import AuthContext from "store/context/PublicContext"
import { logInAction, logOutAction } from "store/actions/publicActions"
import { SIMO_VAR, SIMO_VAR_POSTRENDER, SIMO_VAR_PRERENDER } from "constants/APP_CONSTANTS"
import { sharedStorage } from "utils/sharedStorage"
import { useAuth0 } from "@auth0/auth0-react"
import useAuth0Credentials from "./useAuth0Credentials"

interface ILoginData {
  user: string
  password: string
}

interface IErrorLogin {
  code: number
  message: string
}

const useLogin = () => {
  const [error_login, set_error_login] = useState<IErrorLogin>({
    code: 0,
    message: "",
  })
  const { newCancelToken, isCancel } = useCancelToken()
  const { clientId } = useAuth0Credentials()
  const { logout: logout_auth0 } = useAuth0()

  const { dispatch } = useContext(AuthContext)

  const { set_loading_app } = useContext(AppContext)
  const navigate = useNavigate()

  const login_user_action = async (body: ILoginData) => {
    try {
      set_loading_app(true)
      set_error_login({
        code: 0,
        message: "",
      })
      let {
        data: { message },
      }: any = await login_user_service(body, newCancelToken())
      const { id, name, role, email, token } = message
      console.log(message)
      dispatch(logInAction({ id, name, role, email, token }))
      set_loading_app(false)
      navigate("/dashboard")
    } catch (error: any) {
      set_loading_app(false)
      set_error_login({
        code: error?.response?.status,
        message: error.response?.data?.message,
      })
      if (isCancel(error)) return
    }
  }

  const logout_user_action = () => {
    // Clear simo-v4 specific storage
    localStorage.removeItem(SIMO_VAR)
    localStorage.removeItem(SIMO_VAR_PRERENDER)
    localStorage.removeItem(SIMO_VAR_POSTRENDER)

    // Clear shared cross-domain storage (compatible with xmonitor modules)
    sharedStorage.clearAll()

    dispatch(logOutAction)
    logout_auth0({ logoutParams: { returnTo: window.location.origin, client_id: clientId, federated: true } } as any)
  }

  return {
    login_user_action,
    logout_user_action,
    error_login,
  }
}

export default useLogin
